import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {QuestionOptions} from 'src/app/constants/question-options';
import {CustomValidators} from '../../../../../validator/custom-validator';
import {Offer} from '../../../../../model/offer/offer';
import {ExternalInsurer} from '../../../../../model/offer/external-insurer';
import {OfferFormBase} from '../../../create-offer-tab/create-offer-elements/offer-form-base/offer-form-base.component';
import {ReplaySubject, takeUntil} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-external-insurer-form',
    templateUrl: './external-insurer-form.component.html',
    styleUrls: ['../../../../../../styles/form-input.scss'],
    providers: [{ provide: OfferFormBase, useExisting: ExternalInsurerFormComponent }],
    standalone: false
})
export class ExternalInsurerFormComponent extends OfferFormBase implements OnInit{
  QuestionOptions = QuestionOptions;

  public filterCtrlCountry: FormControl<string> = new FormControl<string>('');
  public filterCtrlCountryCode: FormControl<string> = new FormControl<string>('');

  public filteredOptionsCountry: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);
  public filteredOptionsCountryCode: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);

  formGroup = this.fb.group({
    name: ['', [Validators.required, CustomValidators.notOnlyWhitespace]],
    streetName: ['', [Validators.required, CustomValidators.notOnlyWhitespace]],
    houseNumber: ['', [Validators.required, CustomValidators.notOnlyWhitespace]],
    postalCode: ['', [Validators.required, CustomValidators.notOnlyWhitespace]],
    location: ['', [Validators.required, CustomValidators.notOnlyWhitespace]],
    countryCode: ['', [Validators.required, CustomValidators.notOnlyWhitespace]],
  });

  countryOptions: string[] = [];
  countryCodeOptions: string[] = QuestionOptions.countryCodes;

  constructor(private readonly fb: FormBuilder,
              private readonly translate: TranslateService) {
    super();
  }

  ngOnInit() {

    QuestionOptions.countryCodes.forEach(code =>
      this.countryOptions.push(this.translate.instant('countryCodes.' + code))
    );

    this.filteredOptionsCountry.next(this.countryOptions.slice());
    this.filteredOptionsCountryCode.next(this.countryCodeOptions.slice());

    this.filterCtrlCountryCode.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.filterCountries(this.filterCtrlCountryCode.value, this.countryCodeOptions, this.filteredOptionsCountryCode);
      });

    this.filterCtrlCountry.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.filterCountries(this.filterCtrlCountry.value, this.countryOptions, this.filteredOptionsCountry);
      });
  }

  updateOffer(offer: Offer) {
    offer.externalInsurer = new ExternalInsurer(this.formGroup.getRawValue());
  }

  filterCountries(search: string, options, filtered) {
    if (!options) {
      return;
    }
    if (!search) {
      filtered.next(options.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    filtered.next(
      options.filter(country => country.toLowerCase().indexOf(search) > -1)
    );
  }

  getCountryCodeFromCountry(selectedCountry: string): string {
    const index = this.countryOptions.findIndex(country => country === selectedCountry);
    return index !== -1 ? this.countryCodeOptions[index] : '';
  }

  prefill(offer: Offer): void {
    if (!offer.externalInsurer) return;

    this.formGroup.patchValue({
      name: offer.externalInsurer.name || '',
      streetName: offer.externalInsurer.streetName || '',
      houseNumber: offer.externalInsurer.houseNumber || '',
      postalCode: offer.externalInsurer.postalCode || '',
      location: offer.externalInsurer.location || '',
      countryCode: offer.externalInsurer.countryCode || ''
    });
  }

}
